<template>
  <div class="state-selector">
    <div :style="{color: currentState.color}">
      {{ currentState.label }}
    </div>
  </div>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import { get, find, defaultTo } from 'lodash'
import { createDataTypeValue } from '../utils'

export default {
    name: 'EntityStateDetail',
    mixins: [
        DataTypeProsMixin,
    ],
    data() {
        return {
            opened: false,
        }
    },
    computed: {
        valueHandler: {
            get() {
                return get(this, 'value.value.value', null)
            },
            set(value) {
                this.$emit('input', createDataTypeValue(value))
            },
        },
        graph() {
            const graph = get(this.$store.getters.currentUser, `company.settings.entity-states.graphs.${this.graphId}`, {})
            return graph
        },
        graphId() {
            return get(this.meta, `taskType.settings.graphs.${this.id}`, {})
        },
        states() {
            return get(this.$store.getters.currentUser, `company.settings.entity-states.states`, {})
        },
        currentState() {
            return defaultTo(find(this.states, s => s.id === this.valueHandler), {})
        },
    },
}
</script>
